<template>
  <div class="main-content ipNumbers">
    <div class="card">
      <div class="card-header">
        <h5>IP телефоны</h5>
      </div>
      <div class="card-body">

        <div>
          <h6>Новый номер</h6>
          <form @submit.prevent="updateRecords('new')">
            <div class="flex new_record_block">
              <div class="form-group">
                <label for="">Телефон для отображения</label>
                <input v-model="newRecord.display_phone" type="text" required class="form-control">
              </div>
              <div class="form-group">
                <label for="">Формат</label>
                <input v-model="newRecord.phone" required type="text" class="form-control">
              </div>
              <div class="form-group">
                <label for="">Описание</label>
                <input v-model="newRecord.description" required type="text" class="form-control">
              </div>
              <div class="form-group">
                <label for="">Сайт</label>
                <select class="form-control" v-model="newRecord.site_id" required>
                  <option value="0">Все проекты</option>
                  <option v-if="project.id" v-for="project in $AllProjects" :value="project.id">{{
                      project.name
                    }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="">Город</label>
                <select class="form-control" v-model="newRecord.city_id" required>
                  <option v-if="city.id" v-for="city in $AllCities" :value="city.id">{{ city.short_name }} -
                    {{ city.name }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label for="">MANGO ID</label>
                <select class="form-control" v-model="newRecord.service_id">
                  <option v-for="(title, accId) in mangoAccs" :value="accId">{{ title }}</option>
                </select>
                <!--                <input v-model="newRecord.service_id" type="text" required class="form-control max-width-100">-->
              </div>
            </div>
            <div class="text-right">
              <vue-ladda button-class="btn btn-sm btn-success"
                         data-style="zoom-in"
                         type="submit"
                         :loading="saveLoading">Сохранить новый номер
              </vue-ladda>
            </div>
          </form>
          <hr>
        </div>

        <div class="flex justify-content-between">
          <div>
            <select class="form-control" v-model="filter.site_id">
              <option value="0">Все проекты</option>
              <option v-for="project in $AllProjects" :value="project.id">{{ project.title }}</option>
            </select>
          </div>
          <div>
            <vue-ladda button-class="btn btn-outline-info"
                       data-style="zoom-in"
                       type="button"
                       @click="getRecords"
                       :loading="saveLoading">Показать
            </vue-ladda>
          </div>
        </div>

        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="records">
          <table class="table table-sm table-hover mt-3">
            <thead>
            <tr>
              <th></th>
              <th>Телефон для отображения</th>
              <th>Формат</th>
              <th>Описание</th>
              <th>Сайт</th>
              <th>Город</th>
              <th>Mango Acc</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in records" v-bind:class="{'modified': record.modified}">
              <td>{{ (index + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td><input type="text" @change="() => record.modified = true" class="form-control"
                         v-model="record.display_phone"/></td>
              <td><input type="text" @change="() => record.modified = true" class="form-control"
                         v-model="record.phone"/></td>
              <td><input type="text" @change="() => record.modified = true" class="form-control"
                         v-model="record.description"/></td>
              <td>
                <select @change="() => record.modified = true" class="form-control" v-model="record.site_id">
                  <option value="0">Все проекты</option>
                  <option v-if="project.id" :disabled="!project.is_active" v-for="project in $AllProjects" :value="project.id">{{
                      project.name
                    }}
                  </option>
                </select>
              </td>
              <td>
                <select @change="() => record.modified = true" class="form-control" v-model="record.city_id">
                  <option v-if="city.id" v-for="city in $AllCities" :value="city.id">{{ city.short_name }} -
                    {{ city.name }}
                  </option>
                </select>
              </td>
              <td>
                <select class="form-control" v-model="record.service_id" @change="() => record.modified = true">
                  <option v-for="(title, accId) in mangoAccs" :value="accId">{{ title }}</option>
                </select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="flex justify-content-between">
          <paginate v-if="false && paginator"
                    v-model="currentPage"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
          <div>
            <vue-ladda @click="updateRecords()" button-class="btn btn-sm btn-success"
                       data-style="zoom-in"
                       :loading="saveLoading">Сохранить
            </vue-ladda>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Paginate from 'vuejs-paginate'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    Paginate,
    VueLadda,
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      records: null,
      mangoAccs: {},
      filter: {
        site_id: 0
      },
      paginator: null,
      currentPage: 1,
      newRecord: {}
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects']
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  async mounted() {
    await this.getRecords()
  },
  methods: {
    async updateRecords(action = 'update') {
      const records = this.records.filter((r) => r.modified)
      // if (!records.length) return;
      this.saveLoading = true
      let {data} = await api.post('/telephony/ipNumbers', {
        action, records,
        newRecord: this.newRecord,
        filter: this.filter
      })
      if (!data.success) {
        this.Toast.fire({
          type: 'warning',
          title: data.message || 'Ошибка'
        })
      } else {
        this.Toast.fire({
          type: 'success',
          title: 'Сохранено'
        })
        if (action === 'new') {
          this.newRecord = {}
        }
        await this.getRecords(this.currentPage)
      }
      this.saveLoading = false
    },
    async getRecords(page = 1) {
      this.records = null
      this.paginator = null
      this.loading = true
      let {data: r_data} = await api.post('/telephony/ipNumbers?page=' + page, {
        filter: this.filter
      })
      if (!r_data.success) {
        this.Toast.fire({
          type: 'warning',
          title: r_data.message || 'Ошибка'
        })
        return
      }
      const {data, ...pagination} = r_data.records
      this.loading = false
      this.mangoAccs = r_data.mangoAccs
      this.records = data.map((r) => {
        r.modified = false
        return r
      })
      this.paginator = pagination
      this.currentPage = this.paginator.current_page
    }
  }
}

</script>

<style>

.ipNumbers .table .modified input,
.ipNumbers .table .modified select {
  border: 1px solid blue;
}

</style>

<style scoped>
.new_record_block .form-group {
  margin-right: 10px;
}

.max-width-100 {
  width: 70px;
}

table.table td {
  padding: 5px;
}
</style>
